import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsMemberChoose } from "../../Services/redux/chooseMember";
import axios from "axios";
import { updateFinYear } from "../../Services/redux/finYearReducer";
const updateFinYearURL = `${process.env.REACT_APP_API_URL}api/change-working-finyear`;

const DropdownListMobile = ({
  data,
  routeName,
  handleClose,
  workingFinYear,
  finYearList,
  setNavToggle,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const prevState = location.state || {};

  const apiOption = {
    headers: {
      Authorization: `Bearer ${
        sessionStorage.getItem("subscriberToken")
          ? sessionStorage.getItem("subscriberToken")
          : sessionStorage.getItem("token")
      }`,
    },
  };

  const token = sessionStorage.getItem("subscriberToken")
    ? sessionStorage.getItem("subscriberToken")
    : sessionStorage.getItem("token");

  useEffect(() => {
    if (token) {
      dispatch(updateFinYear(workingFinYear));
    }
  }, [workingFinYear]);

  const handleFinYear = async (e) => {
    sessionStorage.setItem("CorporateActionMaster", 1);
    sessionStorage.setItem("Contract Note", 1);
    sessionStorage.removeItem("EligibleTaskId");
    sessionStorage.removeItem("CapitalGLDetailedTaskId");
    sessionStorage.removeItem("CapitalGLSummaryTaskId");
    sessionStorage.removeItem("F&OPositionTaskId");
    sessionStorage.removeItem("F&OPLTaskId");
    sessionStorage.removeItem("TaskId");
    sessionStorage.removeItem("taskStatus");
    sessionStorage.removeItem("CorporateActionMaster");
    sessionStorage.removeItem("corporate_action");
    sessionStorage.removeItem("ca_master_scrip");
    sessionStorage.removeItem("ex_from");
    sessionStorage.removeItem("ex_to");
    sessionStorage.removeItem("caa_status");
    sessionStorage.removeItem("contractData");
    sessionStorage.removeItem("contractBroker");
    sessionStorage.removeItem("Contract Note");
    sessionStorage.removeItem("uploadedFrom");
    sessionStorage.removeItem("uploadedTo");
    sessionStorage.removeItem("tradeDateFrom");
    sessionStorage.removeItem("tradeDateTo");
    try {
      const [finYearId, name, name2] = e.target.value.split(" ");

      if (sessionStorage.getItem("subscriberToken")) {
        sessionStorage.setItem("subFinYearID", finYearId);
      }
      sessionStorage.setItem("finYearID", finYearId);

      if (name2) {
        sessionStorage.setItem("finYear", name2);
        sessionStorage.setItem("finYearChanged", "yes");
      }

      const data = {
        new_fin_year_id: finYearId,
      };

      await axios.post(updateFinYearURL, data, apiOption);
      dispatch(updateFinYear(name + " " + name2));
      navigate(location.pathname, {
        replace: true,
        state: { ...prevState, workingFinYear: true },
      });
      sessionStorage.removeItem("contractData");
    } catch (error) {
      console.error(error);
    }
  };

  const handleLogOut = () => {
    if (!sessionStorage.getItem("subscriberToken")) {
      dispatch({
        type: "setAuthToken",
        payload: {
          token: "",
        },
      });
      navigate("/");
    } else {
      navigate("/UzAJ/y4fN/kdSuVuxGEcEw==", {
        replace: true,
        state: { ...prevState, workingFinYear: true, permittedFyList: true },
      });
    }
    dispatch({
      type: "logout",
    });
  };

  const handleGoHome = () => {
    navigate(`/UzAJ/y4fN/kdSuVuxGEcEw==`);
    dispatch(setIsMemberChoose(true));
  };

  const navigation = (item, replace) => {
    if (
      item.name === "Corporate Action Ledger" ||
      item.name === "Eligible Holding"
    ) {
      navigate(`/${item.url.substring(1)}`);
    } else if (item.name === "Select Subscribers") {
      handleGoHome();
    } else if (item.name === "Log Out") {
      handleLogOut();
    } else {
      navigate(`/${item.url}`);
    }
    handleClose();
  };

  const directLinks = ["opening-stock", "bank-statement"];
  return (
    <>
      <div className=" flex w-full  flex-col capitalize">
        <div className=" rounded-b-md bg-[#30265b] shadow-md">
          {routeName === "profile"
            ? data
                ?.filter((item) => item?.action_pages === "")
                ?.sort((a, b) => a.submenu_sortorder - b.submenu_sortorder)
                .map((item) => (
                  <div
                    key={item.value}
                    className=" w-full border-b-[1px]  border-b-[#c6c6c6] px-6 py-4 text-white"
                    onClick={() => {
                      navigation(item);
                      setNavToggle();
                    }}
                  >
                    {item.name}
                  </div>
                ))
            : data
                ?.filter((item) => item?.action_pages === "")
                ?.sort((a, b) => a.submenu_sortorder - b.submenu_sortorder)
                .map((item) => (
                  <div
                    key={item.value}
                    className=" w-full border-b-[1px]  border-b-[#c6c6c6] px-6 py-4 text-white"
                    onClick={() => {
                      navigation(item);
                      setNavToggle();
                    }}
                  >
                    {item.name}
                  </div>
                ))}

          {routeName === "finyear" &&
            finYearList?.map((yearData, idx) => (
              <option
                key={idx}
                value={`${yearData?.id} ${yearData?.fin_year_name}`}
                onClick={(e) => {
                  handleFinYear(e);
                  setNavToggle();
                }}
                className=" w-full border-b-[1px]  border-b-[#c6c6c6] px-6 py-4 text-white"
              >
                {yearData?.fin_year_name}
              </option>
            ))}
        </div>
      </div>
    </>
  );
};

export default DropdownListMobile;
